import * as moment from "moment";
import { IsPrimaryAttribute } from "source/app/presentation/MainPanel/Dreams/DreamAttributeIcon/AttributeMap/AttributeMap";
import { IDataProvider } from "../Data/IDataProvider";
import { EDA } from "../Dreams/EDreamAttribute";
import IDream from "../Entity/IDream";
import { dreamRepository } from "../Repositories/DreamRepository";

const DreamService = () => {
    function GetDreamAgeInMinutes(dream: IDream) {
        return moment().diff(moment(dream.lastmodifiedtime), "minutes");
    }

    async function UpdateDreamAsync(
        dream: IDream,
        dataProvider: IDataProvider
    ) {
        return dreamRepository.UpdateDreamAsync(dream, dataProvider);
    }

    async function SwapAttribute(
        dream: IDream,
        dataProvider: IDataProvider,
        attributeToRemove: EDA,
        attributeToAdd: EDA
    ) {
        const updatedDream = Object.assign({}, dream);

        updatedDream.attributes = updatedDream.attributes.filter(
            (a) => a !== EDA[attributeToRemove]
        );

        updatedDream.attributes.push(EDA[attributeToAdd]);

        return UpdateDreamAsync(updatedDream, dataProvider);
    }

    const FilterDreamsForAttribute = (dreams: IDream[], attribute: EDA) =>
        dreams.filter((dream) => DoesDreamHaveAttribute(dream, attribute));

    function DoesDreamHaveAttribute(dream: IDream, attribute: EDA) {
        const attributeName = EDA[attribute];
        return dream.attributes.includes(attributeName);
    }

    function DoesDreamHavePrimaryAttribute(dream: IDream) {
        const result =
            dream.attributes.filter((attribute) =>
                IsPrimaryAttribute(attribute)
            ).length > 0;

        return result;
    }

    const IsTodaysDream = (dream: IDream) => dream.isresonating;

    const IsAdjacentDream = (dream: IDream) =>
        dream.difficulty <= 5 &&
        !DoesDreamHavePrimaryAttribute(dream) &&
        !DoesDreamHaveAttribute(dream, EDA.fixed) &&
        !DoesDreamHaveAttribute(dream, EDA.waypoint);

    const GetDopamineValue = (text: string) => {
        const regex = /\[(-?\d+)\]/;
        const dopamineMatch = text.match(regex);

        const result = dopamineMatch
            ? Number.parseInt(dopamineMatch[1])
            : undefined;

        return result;
    };

    const IsPromiseAbbreviation = (text: string) => text.includes(`P:`);

    const IsPromiseDate = (text: string) => {
        const regex = /\(\d{8}\)/;
        return regex.test(text);
    };

    const IsBoldedWord = (text: string) => {
        const regex = /_(\w+)_/;
        return regex.test(text);
    };

    const IsProject = (text: string) => {
        const regex = /\[.*?\]/;
        return regex.test(text);
    };

    return {
        GetDreamAgeInMinutes,
        UpdateDreamAsync,
        SwapAttribute,
        DoesDreamHaveAttribute,
        DoesDreamHavePrimaryAttribute,
        FilterDreamsForAttribute,
        IsTodaysDream,
        IsAdjacentDream,
        GetDopamineValue,
        IsPromiseAbbreviation,
        IsPromiseDate,
        IsBoldedWord,
        IsProject,
    };
};

export const dreamService = DreamService();
